/* import __COLOCATED_TEMPLATE__ from './french-settings.hbs.js'; */
var _class, _descriptor, _FrenchSettings_brand;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { PLACEHOLDER_SECTIONS } from '@qonto/ui-kit/constants/pdf-preview';
let FrenchSettings = (_class = (_FrenchSettings_brand = /*#__PURE__*/new WeakSet(), class FrenchSettings extends Component {
  constructor(...args) {
    super(...args);
    _classPrivateMethodInitSpec(this, _FrenchSettings_brand);
    _initializerDefineProperty(this, "intl", _descriptor, this);
  }
  get transactionType() {
    let type = this.args.settings?.transactionType;
    return this.intl.t(`ui-kit.pdf-preview.transaction-type.${type}`, {
      language: this.args.displayLanguage
    });
  }
  get vatPaymentCondition() {
    let condition = this.args.settings?.vatPaymentCondition;
    return this.intl.t(`ui-kit.pdf-preview.payment-condition.${condition}`, {
      language: this.args.displayLanguage
    });
  }
  get tcLink() {
    return this.args.settings?.tcLinkText;
  }
  get placeholderConfig() {
    return this.args.placeholderConfig || {};
  }
  get enablePlaceholders() {
    return this.placeholderConfig.enablePlaceholders;
  }
  get showDiscountConditions() {
    return _assertClassBrand(_FrenchSettings_brand, this, _showSectionValue).call(this, 'TERMS_AND_CONDITIONS', this.args.settings?.discountConditions);
  }
  get showLegalFixedCompensation() {
    return _assertClassBrand(_FrenchSettings_brand, this, _showSectionValue).call(this, 'TERMS_AND_CONDITIONS', this.args.settings?.legalFixedCompensation);
  }
  get showLatePaymentPenalties() {
    return _assertClassBrand(_FrenchSettings_brand, this, _showSectionValue).call(this, 'TERMS_AND_CONDITIONS', this.args.settings?.latePaymentPenalties);
  }
  get showTcLink() {
    return _assertClassBrand(_FrenchSettings_brand, this, _showSectionValue).call(this, 'TERMS_AND_CONDITIONS', this.tcLink);
  }
}), _descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
function _showSectionValue(section, value) {
  return !this.enablePlaceholders || this.enablePlaceholders && this.placeholderConfig.activeSections?.includes(PLACEHOLDER_SECTIONS[section]) && value;
}
export { FrenchSettings as default };